import React, {createContext, ReactNode, useContext, useState} from 'react';
import {api} from "../services/api";
import {useNotification} from "./NotificationContext";
import {Modal} from "react-bootstrap";

interface DeleteModalContextType {
  openDeleteModal: (apiUrl: string, itemId: number | string, onSuccess?: () => void) => void;
}

interface DeleteConfig {
  apiUrl: string;
  itemId: number | string | null;
  onSuccess?: () => void;
}

interface DeleteModalProviderProps {
  children: ReactNode;
}

const DeleteModalContext = createContext<DeleteModalContextType | undefined>(undefined);

export const DeleteModalProvider: React.FC<DeleteModalProviderProps> = ({children}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {showNotification} = useNotification()
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deleteConfig, setDeleteConfig] = useState<DeleteConfig>({
    apiUrl: '',
    itemId: null,
    onSuccess: undefined,
  });

  const openDeleteModal = (apiUrl: string, itemId: number | string, onSuccess?: () => void) => {
    setDeleteConfig({apiUrl, itemId, onSuccess});
    setIsOpen(true);
  };

  const closeDeleteModal = () => {
    setIsOpen(false);
    setDeleteConfig({apiUrl: '', itemId: null, onSuccess: undefined});
  };

  const handleDelete = async () => {
    try {
      setIsSubmitting(true);
      const {apiUrl, itemId, onSuccess} = deleteConfig;
      if (!itemId) return;
      try {
        const res = await api.delete(`${apiUrl}${itemId}/`);
        if (res.status === 204) {
          showNotification("Muvaffaqiyatli!", "Ma'lumot o'chirildi", "success")
        }
      } catch (e) {
        showNotification("Xatolik!", "Ma'lumot o'chirishda xatolik!", "error");
      }
      if (onSuccess) {
        onSuccess()
      }
      closeDeleteModal();
      setIsSubmitting(false);
    } catch (error) {
      showNotification("Xatolik!", "Ma'lumot o'chirishda xatolik!", "error");
      setIsSubmitting(false);
    }
  };

  return (
      <DeleteModalContext.Provider value={{openDeleteModal}}>
        {children}
        <Modal show={isOpen} onHide={closeDeleteModal}>
          <div className="modal-content">
            <Modal.Header closeButton>
              <Modal.Title>O'chirishni tasdiqlash</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
              <p>Haqiqattan o'chirmoqchimisiz?</p>
            </Modal.Body>
            <Modal.Footer>
              <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeDeleteModal}
              >
                Bekor qilish
              </button>
              <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                  disabled={!deleteConfig.itemId || isSubmitting}
              >
                {isSubmitting ? "O'chirilyapti..." : "O'chirish"}
              </button>
            </Modal.Footer>
          </div>
        </Modal>
      </DeleteModalContext.Provider>
  );
};

export const useDeleteModal = (): DeleteModalContextType => {
  const context = useContext(DeleteModalContext);
  if (!context) {
    throw new Error('useDeleteModal must be used within a DeleteModalProvider');
  }
  return context;
};